<template>
  <div class="glass-card p-6 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 group">
    <div class="flex justify-between items-start">
      <div>
        <p v-if="link" class="cursor-pointer text-sm font-semibold text-gray-600 dark:text-gray-300"><span @click="$router.push('/config')">{{ title }}</span></p>
        <p v-else class="text-sm font-semibold text-gray-600 dark:text-gray-300">{{ title }}</p>
        <p class="text-3xl font-bold text-gray-900 dark:text-white mt-2 group-hover:scale-105 transition-transform">{{ value }}</p>
      </div>
      <div class="p-3 glass-subtle rounded-xl group-hover:animate-glow transition-all">
        <component :is="icon" class="w-7 h-7 text-primary dark:text-white"></component>
      </div>
    </div>
    <div v-if="trend" class="flex items-center mt-4">
      <component
        :is="trend >= 0 ? ArrowUpRight : ArrowDownRight"
        class="w-5 h-5"
        :class="trend >= 0 ? 'text-success' : 'text-danger'"
      ></component>
      <span
        class="text-sm ml-1 font-medium"
        :class="trend >= 0 ? 'text-success' : 'text-danger'"
      >
        {{ Math.abs(trend) }}% from last period
      </span>
    </div>
  </div>
</template>

<script>
import { ArrowUpRight, ArrowDownRight } from "lucide-vue-next";

export default {
  name: "StatCard",
  components: {
    ArrowUpRight,
    ArrowDownRight,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: [Number, String],
      required: true,
    },
    icon: {
      type: [String, Function, Object],
      required: true,
    },
    trend: {
      type: Number,
      default: null,
    },
    link: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      ArrowUpRight,
      ArrowDownRight,
    };
  },
};
</script>
